module.exports = __webpack_public_path__ + "img/qrcode_service.2874ae4b.png";